
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93YglhAfLGepnU6_QPPzoANse_MW2WYXdOV748UAMMzGoMeta } from "/vercel/path0/website/pages/[...slug].vue?macro=true";
import { default as component_45stubjQ5k14SqF8KqTQaeks4ziWtIvBJwtNsmX4NC3paSjloMeta } from "/vercel/path0/website/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubjQ5k14SqF8KqTQaeks4ziWtIvBJwtNsmX4NC3paSjlo } from "/vercel/path0/website/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93YglhAfLGepnU6_QPPzoANse_MW2WYXdOV748UAMMzGoMeta || {},
    component: () => import("/vercel/path0/website/pages/[...slug].vue")
  },
  {
    name: component_45stubjQ5k14SqF8KqTQaeks4ziWtIvBJwtNsmX4NC3paSjloMeta?.name,
    path: "/apple-touch-icon-120x120.png",
    component: component_45stubjQ5k14SqF8KqTQaeks4ziWtIvBJwtNsmX4NC3paSjlo
  },
  {
    name: component_45stubjQ5k14SqF8KqTQaeks4ziWtIvBJwtNsmX4NC3paSjloMeta?.name,
    path: "/apple-touch-icon-120x120-precomposed.png",
    component: component_45stubjQ5k14SqF8KqTQaeks4ziWtIvBJwtNsmX4NC3paSjlo
  },
  {
    name: component_45stubjQ5k14SqF8KqTQaeks4ziWtIvBJwtNsmX4NC3paSjloMeta?.name,
    path: "/apple-touch-icon-152x152.png",
    component: component_45stubjQ5k14SqF8KqTQaeks4ziWtIvBJwtNsmX4NC3paSjlo
  },
  {
    name: component_45stubjQ5k14SqF8KqTQaeks4ziWtIvBJwtNsmX4NC3paSjloMeta?.name,
    path: "/apple-touch-icon-152x152-precomposed.png",
    component: component_45stubjQ5k14SqF8KqTQaeks4ziWtIvBJwtNsmX4NC3paSjlo
  }
]